import { useRef, useState } from "react";

export const useBreakdownValueAlert = (performedAction) => {
  const [valueAlertVisible, showAlertVisible] = useState(false);
  
  const changeValueData = useRef();
  
  const handleValueAlertClose = async (clearChildren/*e, lock*/) => {
    showAlertVisible(false);
    
    if(typeof clearChildren === "undefined") return;
    if(changeValueData.current) {
      performedAction(changeValueData.current, clearChildren);
      changeValueData.current = undefined;
    }
    
    // if (lock) {
    //   editorStore.blockedValueAlert = true;
    //   await setCompanySettingsQuery(PROJECT_COMPANY_SETTINGS.VALUE_ALERT(isTemplate ? `t-${estimateUuid}` : estimateUuid), true)
    // }
  };
  
  const handleValueAlertOpen = (savedActionData) => {
    // if(!editorStore?.blockedValueAlert)
    changeValueData.current = savedActionData;
    setTimeout(() => showAlertVisible(true), 100);
  }
  
  return {
    valueAlertVisible,
    handleValueAlertClose,
    handleValueAlertOpen,
  }
}